var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgZhCNreact = function SvgZhCNreact(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B55",
    d: "M23.55 21H.45Q0 21 0 20.55V3.45Q0 3 .45 3h23.1q.45 0 .45.45v17.1q0 .45-.45.45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE15A",
    d: "M4.05 5.85 4.5 7.2h1.2c.15 0 .3.3.15.3l-1.05.9.45 1.35c0 .15-.15.3-.3.15L3.9 9l-1.05.9c-.15.15-.3 0-.3-.15L3 8.4l-1.05-.9c-.15-.15 0-.3.15-.3h1.2l.45-1.35c0-.15.15-.15.3 0M8.55 6.15l.3.45.45-.15s.15 0 0 .15l-.3.45.3.45v.15l-.45-.15-.3.45H8.4v-.6l-.45-.15v-.15l.45-.15zc-.15 0 0 0 0 0M6.75 4.8h.45l.15-.45h.15l.15.6h.45s.15.15 0 .15l-.45.3.15.6s0 .15-.15 0l-.3-.3-.3.3s-.15 0-.15-.15l.15-.45zc0 .15 0 0 0 0M7.5 10.2l-.3.45-.45-.15s-.15 0 0 .15l.3.45-.3.45v.15l.45-.15.3.45h.15v-.6l.45-.15v-.15l-.45-.15zq.225-.225 0 0M9.3 8.85h-.45L8.7 8.4h-.15L8.4 9h-.45s-.15.15 0 .15l.45.3-.15.6s0 .15.15 0l.3-.3.45.3s.15 0 .15-.15l-.15-.45zc0 .15 0 0 0 0"
  })));
};
export default SvgZhCNreact;